<template>
  <div class="settlement-report-page">
    <table
      v-if="showReport"
      class="settlement-report-table"
      cellpadding="0"
      cellspacing="0"
    >
      <thead>
        <tr>
          <th rowspan="2">交易日期</th>
          <th colspan="4">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                text-align: right;
                padding-right: 12px;
              "
            >
              <span style="margin-right: 8px">总项</span>
              <div class="point"></div>
            </div>
          </th>
          <th rowspan="2">实际结果</th>
        </tr>
        <tr>
          <th class="bg">单数</th>
          <th class="bg">下注金额</th>
          <th class="bg">有效金额</th>
          <th class="bg">退水结果</th>
        </tr>
      </thead>
      <tbody>
        <tr
          data-date="2020-03-02"
          class="cursor"
          v-for="(item, index) in list.slice(0, 7)"
          :key="index"
          @click="toReportDetail(item)"
        >
          <td class="active-text">{{ item.betDate + " " + item.week }}</td>
          <td>{{ item.num || 0 }}</td>
          <td style="">{{ (item.betMoney * 1).toFixed(2) }}</td>
          <td :class="item.vaildMoney * 1 <= 0 ? 'green' : 'red'">
            {{ (item.vaildMoney * 1).toFixed(2) }}
          </td>
          <td :class="item.afterBackMoney * 1 <= 0 ? 'green' : 'red'">
            {{ (item.afterBackMoney * 1).toFixed(2) }}
          </td>
          <td :class="item.actualMoney * 1 <= 0 ? 'green' : 'red'">
            {{ (item.actualMoney * 1).toFixed(2) }}
          </td>
        </tr>
        <tr class="sum">
          <td class="bold" style="width: 30%">上周</td>
          <td class="bold" style="width: 12.5%">
            {{ sum(list.slice(0, 7), "num") }}
          </td>
          <td class="bold" style="width: 12.5%">
            {{ sum(list.slice(0, 7), "betMoney").toFixed(2) }}
          </td>
          <td class="bold" style="width: 12.5%">
            {{ sum(list.slice(0, 7), "vaildMoney").toFixed(2) }}
          </td>
          <td class="bold" style="width: 12.5%">
            {{ sum(list.slice(0, 7), "afterBackMoney").toFixed(2) }}
          </td>
          <td class="bold" style="width: 20%">
            {{ sum(list.slice(0, 7), "actualMoney").toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="showReport"
      class="settlement-report-table"
      cellpadding="0"
      cellspacing="0"
    >
      <thead>
        <tr>
          <th rowspan="2">交易日期</th>
          <th colspan="4" style="text-align: right; padding-right: 12px">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                text-align: right;
                padding-right: 12px;
              "
            >
              <span style="margin-right: 8px">总项</span>
              <div class="point"></div>
            </div>
          </th>
          <th rowspan="2">实际结果</th>
        </tr>
        <tr>
          <th class="bg">单数</th>
          <th class="bg">下注金额</th>
          <th class="bg">有效金额</th>
          <th class="bg">退水结果</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="cursor"
          v-for="(item, index) in list.slice(7)"
          :key="index"
          @click="toReportDetail(item)"
        >
          <td
            :class="{
              red: item.week.includes('今天'),
              'active-text': !item.week.includes('今天'),
            }"
          >
            {{ item.betDate + " " + item.week }}
          </td>
          <td>{{ item.num || 0 }}</td>
          <td style="">{{ (item.betMoney * 1).toFixed(2) }}</td>
          <td :class="item.vaildMoney * 1 <= 0 ? 'green' : 'red'">
            {{ (item.vaildMoney * 1).toFixed(2) }}
          </td>
          <td :class="item.afterBackMoney * 1 <= 0 ? 'green' : 'red'">
            {{ (item.afterBackMoney * 1).toFixed(2) }}
          </td>
          <td :class="item.actualMoney * 1 <= 0 ? 'green' : 'red'">
            {{ (item.actualMoney * 1).toFixed(2) }}
          </td>
        </tr>
        <tr class="sum">
          <td class="bcg bold" style="width: 30%">本周</td>
          <td class="bcg bold" style="width: 12.5%">
            {{ sum(list.slice(7), "num") * 1 }}
          </td>
          <td class="bcg bold" style="width: 12.5%">
            {{ (sum(list.slice(7), "betMoney") * 1).toFixed(2) }}
          </td>
          <td class="bcg bold" style="width: 12.5%">
            {{ (sum(list.slice(7), "vaildMoney") * 1).toFixed(2) }}
          </td>
          <td class="bcg bold" style="width: 12.5%">
            {{ (sum(list.slice(7), "afterBackMoney") * 1).toFixed(2) }}
          </td>
          <td class="bcg bold" style="width: 20%">
            {{ (sum(list.slice(7), "actualMoney") * 1).toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>

    <input
      class="back-btn btn primary"
      v-if="!showReport"
      type="button"
      value="<<返回"
      @click="back()"
    />

    <el-scrollbar
      class="el-scrollbar"
      style="height: 500px"
      v-if="showReportDetail"
    >
      <table
        class="settlement-report-table report-detail"
        cellpadding="0"
        cellspacing="0"
      >
        <thead>
          <tr>
            <th>彩种类型</th>
            <th>注单笔数</th>
            <th>下注总额</th>
            <th>有效总额</th>
            <th>结果</th>
            <th>退水</th>
            <th>实际结果</th>
          </tr>
        </thead>
        <tbody>
          <tr
            @click="toIssueDetail()"
            class="cursor"
            mystate="3"
            v-if="reportDetail.num != 0"
          >
            <td>{{ reportDetail.gameName }}</td>
            <td>{{ reportDetail.num }}</td>
            <td style="">{{ (reportDetail.betMoney * 1).toFixed(2) }}</td>
            <td style="">{{ (reportDetail.vaildMoney * 1).toFixed(2) }}</td>
            <td :class="reportDetail.afterBackMoney * 1 < 0 ? 'green' : 'red'">
              {{ (reportDetail.afterBackMoney * 1).toFixed(2) }}
            </td>
            <td
              :class="
                reportDetail.actualMoney * 1 - reportDetail.afterBackMoney * 1 <
                0
                  ? 'green'
                  : 'red'
              "
            >
              {{
                (
                  reportDetail.actualMoney * 1 -
                  reportDetail.afterBackMoney * 1
                ).toFixed(2)
              }}
            </td>
            <td :class="reportDetail.actualMoney * 1 < 0 ? 'green' : 'red'">
              {{ (reportDetail.actualMoney * 1).toFixed(2) }}
            </td>
          </tr>
          <tr v-else>
            <td colspan="7">无未结算记录！</td>
          </tr>
          <tr class="sum">
            <td>当前页合计</td>
            <td>{{ reportDetail.num }}</td>
            <td style="">{{ (reportDetail.betMoney * 1).toFixed(2) }}</td>
            <td style="">{{ (reportDetail.vaildMoney * 1).toFixed(2) }}</td>
            <td style="">{{ (reportDetail.afterBackMoney * 1).toFixed(2) }}</td>
            <td style="">
              {{
                (
                  reportDetail.actualMoney * 1 -
                  reportDetail.afterBackMoney * 1
                ).toFixed(2)
              }}
            </td>
            <td :class="reportDetail.actualMoney * 1 < 0 ? 'green' : 'red'">
              {{ (reportDetail.actualMoney * 1).toFixed(2) }}
            </td>
          </tr>
        </tbody>
      </table>
    </el-scrollbar>
    <el-scrollbar
      class="el-scrollbar"
      style="height: 500px"
      v-if="showIssueDetail"
    >
      <table
        class="settlement-report-table issue-detail"
        cellpadding="0"
        cellspacing="0"
      >
        <thead>
          <tr>
            <th>期数</th>
            <th>笔数</th>
            <th>下注金额</th>
            <th>有效金额</th>
            <th>中奖</th>
            <th>回水</th>
            <th>盈亏</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in issueDetail" :key="index">
            <td>{{ item.qihao }}</td>
            <td>{{ item.issueNum }}</td>
            <td style="">{{ (item.betMoney * 1).toFixed(2) }}</td>
            <td style="">{{ (item.vaildMoney * 1).toFixed(2) }}</td>
            <td style="">{{ (item.drawMoney * 1).toFixed(2) }}</td>
            <td style="">{{ (item.backMoney * 1).toFixed(2) }}</td>
            <td style="color: red">{{ (item.winorlose * 1).toFixed(2) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="">
            <th>
              当前页合计：<span name="data-count">{{ issueDetail.length }}</span
              >期
            </th>
            <th style="">
              <span name="data-a">{{ sum(issueDetail, "issueNum") }}</span>
            </th>
            <th style="">
              <span name="data-b">{{
                (sum(issueDetail, "betMoney") * 1).toFixed(2)
              }}</span>
            </th>
            <th style="">
              <span name="data-c">{{
                (sum(issueDetail, "vaildMoney") * 1).toFixed(2)
              }}</span>
            </th>
            <th style="">
              <span name="data-d">{{
                (sum(issueDetail, "drawMoney") * 1).toFixed(2)
              }}</span>
            </th>
            <th style="">
              <span name="data-e">{{
                (sum(issueDetail, "backMoney") * 1).toFixed(2)
              }}</span>
            </th>
            <th
              :class="
                sum(sum(issueDetail, 'winorlose') * 1) < 0 ? 'green' : 'red'
              "
            >
              <span name="data-f">{{
                (sum(issueDetail, "winorlose") * 1).toFixed(2)
              }}</span>
            </th>
          </tr>
        </tfoot>
      </table>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      showReport: true,
      showReportDetail: false,
      showIssueDetail: false,
      reportDetail: null,
      issueDetail: [],
    };
  },
  watch: {
    initFinished() {
      this.initData();
    },
  },
  props: ["initFinished"],
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.initFinished) {
        this.getList();
      }
    },
    async getList() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
      };
      let result = await this.$http.postAxiosMethod("/user/report", data);
      if (result.code == 0) {
        this.list = result.data;
      }
    },
    toReportDetail(item) {
      this.reportDetail = JSON.parse(JSON.stringify(item));
      this.reportDetail.gameName = this.$store.state.gameInfo[0].gameName;
      this.choice("reportDetail");
    },
    async toIssueDetail() {
      let beforeDate =
        this.reportDetail.betDate.substr(0, 4) +
        "-" +
        this.reportDetail.betDate.substr(4, 2) +
        "-" +
        this.reportDetail.betDate.substr(6, 2);
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        beforeDate,
      };
      let result = await this.$http.postAxiosMethod("/user/issuereport", data);
      if (result.code == 0) {
        this.issueDetail = result.data;
      }

      this.choice("issueDetail");
    },
    choice(type) {
      this.showReport = false;
      this.showReportDetail = false;
      this.showIssueDetail = false;
      if (type === "report") {
        this.showReport = true;
      } else if (type === "reportDetail") {
        this.showReportDetail = true;
      } else if (type === "issueDetail") {
        this.showIssueDetail = true;
      } else {
        this.showReport = true;
      }
    },
    back() {
      if (this.showIssueDetail) {
        this.choice("reportDetail");
      } else if (this.showReportDetail) {
        this.choice("report");
      }
    },
    sum(list, key) {
      let sum = 0;
      if (list && Array.isArray(list)) {
        list.forEach((item) => {
          if (key == "num") {
          }
          sum += item[key] * 1;
        });
      }

      return sum || 0;
    },
  },
};
</script>

<style lang="scss">
.settlement-report-page {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>

<style lang="scss" scoped>
.settlement-report-page {
  .back-btn {
    margin: 5px 0;
    //   width: 65px;
    //   height: 30px;
    //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
    //   border-radius: 2px;
    //   font-size: 14px;
    //   color: #fff;
    //   border-radius: 2px;
  }
  .settlement-report-table {
    margin-bottom: 20px;
    width: 100%;
    font-size: 13px;
    border: 1px solid var(--new-border);
    border-right: none;
    border-bottom: none;
    background: var(--new-bg-white);
    tr {
      border: 1px solid var(--new-border);
    }
    th,
    td {
      height: 30px;
      line-height: 30px;
      text-align: center;
      // &:not(:last-child) {
      border-right: 1px solid var(--new-border);
      border-bottom: 1px solid var(--new-border);
      // }
    }
    &.report-detail {
    }
    thead {
      background: var(--new-bg-table-header-main);
    }
    th {
      font-weight: bold;
      // color: #401e1e;
      &.bg {
        background: var(--new-bg-table-header-second);
      }
    }
    tr:not(.sum) {
      cursor: pointer;
    }
    .sum {
      background-color: #f3f5fc;
      td {
        font-weight: bold;
        // color: #401e1e;
      }
    }
  }
  .point {
    display: inline-block;
    position: relative;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid var(--new-primary-color);
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: var(--new-primary-color);
    }
  }
}
</style>
